/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type DocumentResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/upload
 */
export interface UploadRequestBuilder extends BaseRequestBuilder<UploadRequestBuilder> {
    /**
     * Adds one file to the organization's document library. Send it as multipart/form-data: 'file' is required and 'folderId' is optional — leave it out to store the document at the top level. Accepted types are PDF, Word, Excel, PowerPoint, CSV, plain text, and images (JPG, PNG, GIF, WebP). A single file may be up to 50 MB and the organization may hold 1 GB in total; a file that would cross either limit is refused outright rather than stored in part. Uploading a file whose name already exists in the same folder replaces the earlier copy — the old document is removed and the replacement is issued a new document id, so any id held for the old copy stops resolving. The cdnUrl in the response is a time-limited link; when it stops working, ask for a fresh one with the refresh-url endpoint.
     * @param body The multipart/form-data body for uploading one document.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DocumentResponse | undefined>;
    /**
     * Adds one file to the organization's document library. Send it as multipart/form-data: 'file' is required and 'folderId' is optional — leave it out to store the document at the top level. Accepted types are PDF, Word, Excel, PowerPoint, CSV, plain text, and images (JPG, PNG, GIF, WebP). A single file may be up to 50 MB and the organization may hold 1 GB in total; a file that would cross either limit is refused outright rather than stored in part. Uploading a file whose name already exists in the same folder replaces the earlier copy — the old document is removed and the replacement is issued a new document id, so any id held for the old copy stops resolving. The cdnUrl in the response is a time-limited link; when it stops working, ask for a fresh one with the refresh-url endpoint.
     * @param body The multipart/form-data body for uploading one document.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const UploadRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/upload";
/**
 * Metadata for all the requests in the request builder.
 */
export const UploadRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: UploadRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDocumentResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
